(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("Decoupled Front End", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["Decoupled Front End"] = factory(require("react"), require("react-dom"));
	else
		root["Decoupled Front End"] = factory(root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return 